var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy195(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M83.5,19.6C83.4,19.3,83,19,82.6,19h-66c-0.4,0-0.8,0.2-0.9,0.6c-0.2,0.4-0.1,0.8,0.2,1.1l27.6,30l0,28.4 c0,0.4,0.2,0.7,0.5,0.9s0.7,0.2,1-0.1l10.3-7c0.3-0.2,0.4-0.5,0.4-0.8V50.7l27.6-30C83.6,20.4,83.7,20,83.5,19.6z M54,49.7 c-0.2,0.2-0.3,0.4-0.3,0.7v21.3l-8.3,5.6V50.4c0-0.3-0.1-0.5-0.3-0.7L18.9,21h61.4L54,49.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy195);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-195.603b5d6c94748d6d719f08bd9a39d883.svg";
export { ForwardRef as ReactComponent };